import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { debounce } from 'lodash';
import { Row, Col } from 'react-bootstrap';
import {
  InputSearch,
  Alert,
  Pagination,
  Th,
  Td,
  DataStatus,
  Table,
  FilterButton,
  ActionButton,
  BackButton,
  ThFixed,
} from 'components';
import { DateConvert, TableNumber } from 'utilities';
import { PermintaanSubkonProduksiApi } from 'api';
import { useSessionStorage } from 'hooks';
import { IoAddOutline } from 'react-icons/io5';
import { ItemPermintaanCollapse, ModalFilterPreform } from './Components';
import { withDropdownTransferSubkonContextProvider } from './Context';

const TransferSubkonProduksiPreformList = ({ setNavbarTitle }) => {
  const title = 'Transfer Subkon Produksi';
  const history = useHistory();
  const location = useLocation();
  const PAGINATION_KEY = `${location.pathname}_pagination`;

  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useSessionStorage(PAGINATION_KEY, {
    q: '',
    page: '1',
    per_page: '10',
    data_count: '0',
    total_page: '1',

    active: false,
    id_customer: undefined,
    id_proyek: undefined,
    tgl_job_order_start: undefined,
    tgl_job_order_end: undefined,
    id_barang_jadi: undefined,
  });
  const [showFilter, setShowFilter] = useState(false);
  const [data, setData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    variant: 'primary',
    text: '',
  });

  const getInitialData = () => {
    setIsLoading(true);

    PermintaanSubkonProduksiApi.preformPage({
      q: pagination.q,
      page: pagination.page,
      per_page: pagination.per_page,

      tgl_permintaan_produksi_start: pagination.tgl_permintaan_produksi_start,
      tgl_permintaan_produksi_end: pagination.tgl_permintaan_produksi_end,
      id_customer: pagination.id_customer,
      id_proyek: pagination.id_proyek,
      tgl_job_order_start: pagination.tgl_job_order_start,
      tgl_job_order_end: pagination.tgl_job_order_end,
      id_barang_jadi: pagination.id_barang_jadi,
    })
      .then((res) => {
        setData(res?.data?.data ?? []);
        setPagination((prev) => ({
          ...prev,
          total_page: res?.data?.total_page,
          data_count: res?.data?.data_count,
        }));
      })
      .catch(() => {
        setAlertConfig({
          variant: 'danger',
          text: 'Data gagal dimuat',
        });
        setShowAlert(true);
      })
      .finally(() => setIsLoading(false));
  };

  const searchHandler = (e) => {
    const searchKey = e.target.value;

    setPagination({
      ...pagination,
      q: searchKey,
      page: '1',
    });
  };

  useEffect(() => {
    setNavbarTitle(title);
    getInitialData();
  }, [
    setNavbarTitle,
    pagination.q,
    pagination.page,
    pagination.per_page,

    pagination.tgl_permintaan_produksi_start,
    pagination.tgl_permintaan_produksi_end,
    pagination.id_customer,
    pagination.id_proyek,
    pagination.tgl_job_order_start,
    pagination.tgl_job_order_end,
    pagination.id_barang_jadi,
  ]);

  const TableContent = () => {
    return (
      <>
        <div className="font-weight-bold mt-2" style={{ fontSize: '.9rem' }}>
          List Data Permintaan Produksi
        </div>

        <Table>
          <thead>
            <tr className="text-center">
              <Th>No</Th>
              <ThFixed>Informasi Permintaan Produksi</ThFixed>
              <Th style={{ minWidth: 150 }}>Customer</Th>
              <Th style={{ minWidth: 150 }}>Proyek</Th>
              <Th>Informasi Job Order</Th>
              <Th>Item Job Order</Th>
              <Th>Item Permintaan Produksi</Th>
              <Th>Aksi</Th>
            </tr>
          </thead>

          <tbody>
            {data.map((val, index) => (
              <tr key={index}>
                <Td className="text-center align-middle">
                  {TableNumber(pagination.page, pagination.per_page, index)}
                </Td>

                <Td>
                  <div>
                    {val.tgl_permintaan_produksi
                      ? DateConvert(new Date(val.tgl_permintaan_produksi))
                          .detail
                      : '-'}
                  </div>
                  <div>{val.no_permintaan_produksi}</div>
                </Td>

                <Td>{val.nama_customer}</Td>

                <Td>{val.nama_proyek}</Td>

                <Td className="align-middle">
                  <div>
                    {val.tgl_job_order
                      ? DateConvert(new Date(val.tgl_job_order)).detail
                      : '-'}
                  </div>
                  <div>{val.no_job_order}</div>
                </Td>

                <Td className="align-middle">{val.nama_barang_jadi}</Td>

                <Td>
                  <ItemPermintaanCollapse data={val.detail ?? []} />
                </Td>

                <Td className="text-center align-middle">
                  <ActionButton
                    size="sm"
                    onClick={() =>
                      history.push(
                        `/transaksi/transfer-subkon-produksi/tambah/${val.id_permintaan_produksi}`
                      )
                    }
                  >
                    <IoAddOutline />
                  </ActionButton>
                </Td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Pagination
          dataLength={pagination.per_page}
          dataNumber={
            pagination.page * pagination.per_page - pagination.per_page + 1
          }
          dataCount={pagination.data_count}
          currentPage={pagination.page}
          totalPage={pagination.total_page}
          onPaginationChange={({ selected }) =>
            setPagination((prev) => ({ ...prev, page: selected + 1 }))
          }
          onDataLengthChange={(e) =>
            setPagination((prev) => ({
              ...prev,
              page: 1,
              per_page: e.target.value,
            }))
          }
        />
      </>
    );
  };

  return (
    <>
      <Row className="d-flex align-items-center mb-2">
        <Col md="10" className="d-flex">
          <InputSearch
            defaultValue={pagination.q}
            onChange={debounce(searchHandler, 1500)}
          />
          <FilterButton
            active={pagination.active}
            onClick={() => setShowFilter(true)}
          />
        </Col>

        <Col className="d-flex justify-content-end align-items-end">
          <BackButton onClick={() => history.goBack()} />
        </Col>
      </Row>

      <Alert
        show={showAlert}
        showCloseButton={true}
        variant={alertConfig.variant}
        text={alertConfig.text}
        onClose={() => setShowAlert(false)}
      />

      {isLoading === true ? (
        <DataStatus loading={true} text="Memuat data..." />
      ) : data.length > 0 ? (
        <TableContent />
      ) : (
        <DataStatus text="Tidak ada data" />
      )}

      <ModalFilterPreform
        show={showFilter}
        setShow={setShowFilter}
        filter={pagination}
        setFilter={setPagination}
      />
    </>
  );
};

export default withDropdownTransferSubkonContextProvider(
  TransferSubkonProduksiPreformList
);
